import { ComponentType, lazy, LazyExoticComponent, Suspense } from 'react';

import { useAppStore, type IAppStore } from '@/store';
import { Screen } from '@/types';
import useStyles from './styles';

import MobileCreate from '@/components/MobileCreate';

const Loading = lazy(() => import('@/components/Loading'));
const Generations = lazy(() => import('@/components/Generations'));
const CategoryRowsHome = lazy(() => import('@/components/CategoryRowsHome'));

const selector = (store: IAppStore) => ({
  screen: store.screen,
  isSearchOpen: store.isSearchOpen,
});

const overlayComponents: Partial<
  Record<Screen, LazyExoticComponent<ComponentType> | ComponentType>
> = {
  [Screen.Loading]: Loading,
  [Screen.Files]: Generations,
  [Screen.Library]: CategoryRowsHome,
};

const MobileLayout = () => {
  const { screen, isSearchOpen } = useAppStore(selector);
  const classes = useStyles();

  const isFeedOpen = screen === Screen.Create;
  const baseScreen = isFeedOpen ? Screen.Library : screen;
  const BaseScreen = overlayComponents[baseScreen];

  const isCovered = isFeedOpen || isSearchOpen;

  return (
    <div className={classes.mobileContent}>
      {BaseScreen && (
        <div className={classes.screenLayer} hidden={isCovered}>
          <Suspense fallback={null}>
            <BaseScreen />
          </Suspense>
        </div>
      )}
      {isFeedOpen && <MobileCreate />}
    </div>
  );
};

export default MobileLayout;
